module.exports = __webpack_public_path__ + "files/e47671f71aa1d30677158db3f5ee06f6.png";